export enum FacingMode {
  FRONT = 'FRONT',
  REAR = 'REAR'
}

export enum UserRole {
  SPEAKER = 'SPEAKER',
  MODERATOR = 'MODERATOR',
  HOST = 'HOST',
  VIEWER = 'VIEWER'
}

export enum PeerMessageType {
  PROMOTE_TO_MODERATOR = 'PROMOTE_TO_MODERATOR',
  DEMOTE_FROM_MODERATOR = 'DEMOTE_FROM_MODERATOR',
  REMOVE_FROM_STAGE = 'REMOVE_FROM_STAGE',
  REMOVE_INVITEE_FROM_STAGE = 'REMOVE_INVITEE_FROM_STAGE',
  INVITE_TO_STAGE = 'INVITE_TO_STAGE',
  APPROVE_HAND_RAISE = 'APPROVE_HAND_RAISE',
  REJECT_HAND_RAISE = 'REJECT_HAND_RAISE',
  MUTE_AUDIO = 'MUTE_AUDIO',
  DECLINE_JOINING = 'DECLINE_JOINING'
}

export enum ChannelMessageType {
  END_EVENT = 'END_EVENT',
  ENABLE_HAND_RAISE = 'ENABLE_HAND_RAISE',
  DISABLE_HAND_RAISE = 'DISABLE_HAND_RAISE',
  RAISE_HAND = 'RAISE_HAND',
  DROP_HAND = 'DROP_HAND'
}

export enum IdentityProvider {
  FACEBOOK = 'Facebook',
  GOOGLE = 'Google'
}

export enum UserActionType {
  REDIRECT = 'REDIRECT',
  OPEN_FREE_TRIAL_PANEL = 'OPEN_FREE_TRIAL_PANEL',
  OPEN_SETUP_PANEL = 'OPEN_SETUP_PANEL',
  OPEN_SCHEDULE_PANEL = 'OPEN_SCHEDULE_PANEL',
  OPEN_PROFILE_PANEL = 'OPEN_PROFILE_PANEL',
  RAISE_HAND = 'RAISE_HAND',
  DROP_HAND = 'DROP_HAND',
  PUSH_STREAM_TO_YOUTUBE = 'PUSH_STREAM_TO_YOUTUBE',
  PUSH_STREAM_TO_FACEBOOK = 'PUSH_STREAM_TO_FACEBOOK',
  PUSH_STREAM_TO_TWITCH = 'PUSH_STREAM_TO_TWITCH',
  PAYME_ATTEMPTED = 'PAYME_ATTEMPTED'
}

export enum PinMode {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL'
}

export enum StreamingPlatform {
  YOUTUBE = 'YOUTUBE',
  FACEBOOK = 'FACEBOOK',
  TWITCH = 'TWITCH'
}

export enum EventType {
  LIVE_EVENT = 'LIVE_EVENT',
  PAST_EVENT = 'PAST_EVENT'
}

export enum EventStatus {
  ENDED = 'ENDED',
  OVERDUE = 'OVERDUE',
  STARTED = 'STARTED',
  SCHEDULED = 'SCHEDULED'
}

export enum EventLeaveReason {
  END = 'END',
  EXIT = 'EXIT',
  ENDED = 'ENDED',
  JOINED_FROM_ANOTHER_SESSION = 'JOINED_FROM_ANOTHER_SESSION'
}

export enum Layout {
  ACTIVE_SPEAKER = 'ACTIVE_SPEAKER',
  GRID_VIEW = 'GRID_VIEW'
}

export enum PricingPlanProperty {
  STREAM_DURATION = 'STREAM_DURATION',
  CLOUD_STORAGE = 'CLOUD_STORAGE'
}

export enum PricingPlanFeature {
  PUBLIC_EVENT = 'PUBLIC_EVENT',
  MEMBERS_ONLY_EVENT = 'MEMBERS_ONLY_EVENT',
  RECORD_VIDEO = 'RECORD_VIDEO'
}

export enum PricingPlanInterval {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  HALF_YEAR = 'HALF_YEAR',
  YEAR = 'YEAR'
}

export enum PaymentStatus {
  IDLE = 'idle',
  CANCELED = 'canceled',
  PROCESSING = 'processing',
  REQUIRES_ACTION = 'requires_action',
  REQUIRES_CAPTURE = 'requires_capture',
  REQUIRES_CONFIRMATION = 'requires_confirmation',
  REQUIRES_PAYMENT_METHOD = 'requires_payment_method',
  SUCCEEDED = 'succeeded'
}

export enum ShareType {
  COPY = 'COPY',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  NATIVE = 'NATIVE'
}

export module AppStorage {
  export enum Local {
    PERSIST_ROOT = 'persist:root',
    VERSION = 'VERSION',
    LANGUAGE = 'LANGUAGE',
    HAND_RAISE_TOOLTIP_SHOWN = 'HAND_RAISE_TOOLTIP_SHOWN'
  }

  export enum Session {}
}

export module AppTracker {
  export enum ChannelSubscriptionSource {
    CHANNEL_PAGE = 'CHANNEL_PAGE',
    EVENT_DETAIL_PAGE = 'EVENT_DETAIL_PAGE'
  }

  export enum ChannelUnsubscriptionSource {
    CHANNEL_PAGE = 'CHANNEL_PAGE'
  }

  export enum AddToCalendarSource {
    HOME_PAGE = 'HOME_PAGE',
    CHANNEL_PAGE = 'CHANNEL_PAGE',
    EVENT_DETAIL_PAGE = 'EVENT_DETAIL_PAGE'
  }

  export enum LinkStreamingPlatformSource {
    PROFILE_PANEL = 'PROFILE_PANEL',
    SETUP_PANEL = 'SETUP_PANEL'
  }

  export enum ShareSource {
    SHARE_WITH_FRIENDS_PANEL = 'SHARE_WITH_FRIENDS_PANEL',
    SHARE_INVITATION_LINK_PANEL = 'SHARE_INVITATION_LINK_PANEL',
    EVENT_DETAIL_PAGE = 'EVENT_DETAIL_PAGE'
  }

  export enum UpgradePlanSource {
    PROFILE_PANEL = 'PROFILE_PANEL'
  }

  export enum BecomeMemberWithPaymeSource {
    LANDING_PAGE = 'LANDING_PAGE',
    MODAL = 'MODAL'
  }
}

export enum PaymentType {
  CREATOR = 'creator',
  MEMBER = 'member'
}

export module Payme {
  export enum Currency {
    RUB = 643,
    USD = 840,
    UZS = 860,
    EUR = 978
  }

  export enum Language {
    UZ = 'uz',
    RU = 'ru',
    EN = 'en'
  }
}

export enum LiveEventAction {
  PROMOTE_SPEAKER = 'PROMOTE_SPEAKER',
  DEMOTE_MODERATOR = 'DEMOTE_MODERATOR',
  REMOVE_SPEAKER_FROM_STAGE = 'REMOVE_SPEAKER_FROM_STAGE',
  FORCE_MUTE_SPEAKER = 'FORCE_MUTE_SPEAKER',
  TOGGLE_HAND_RAISE_PERMISSION = 'TOGGLE_HAND_RAISE_PERMISSION',
  REJECT_HAND_RAISE_REQUEST = 'REJECT_HAND_RAISE_REQUEST',
  APPROVE_HAND_RAISE_REQUEST = 'APPROVE_HAND_RAISE_REQUEST',
  GENERATE_INVITATION_LINK = 'GENERATE_INVITATION_LINK',
  INVITE_VIEWER_TO_STAGE = 'INVITE_VIEWER_TO_STAGE',
  RAISE_HAND = 'RAISE_HAND',
  DROP_HAND = 'DROP_HAND'
}

export enum LiveEventActionError {
  AUTH_REQUIRED = 'AUTH_REQUIRED'
}

export enum LiveEventTokenSource {
  AUTH = 'AUTH',
  INVITEE_CODE = 'INVITEE_CODE'
}

export enum BottomPanelKey {
  LOGIN = 'LOGIN',
  STUDIO = 'STUDIO',
  GENERATE_INVITATION_LINK = 'GENERATE_INVITATION_LINK',
  SCHEDULE = 'SCHEDULE',
  SETUP = 'SETUP',
  CHOOSE_DATE = 'CHOOSE_DATE',
  CHOOSE_TIME = 'CHOOSE_TIME',
  PROFILE = 'PROFILE',
  REQUESTS = 'REQUESTS',
  UPDATE_PLAN = 'UPGRADE_PLAN',
  EDIT_SCHEDULED_EVENT = 'EDIT_SCHEDULED_EVENT',
  EDIT_CHANNEL_INFO = 'EDIT_CHANNEL_INFO',
  JOIN_THE_STAGE = 'JOIN_THE_STAGE',
  SHARE = 'SHARE',
  ADD_STREAMING_ACCOUNT = 'ADD_STREAMING_ACCOUNT',
  FREE_TRIAL = 'FREE_TRIAL',
  EVENT_IS_OVERDUE = 'EVENT_IS_OVERDUE',
  CONFIRMATION = 'CONFIRMATION',
  PAID_CONTENT = 'PAID_CONTENT'
}
